var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn-primary col-12 no-padding text-18 bold",attrs:{"rel":"nofollow","href":_vm.route('new_property.card', [_vm.propertyId ,_vm.propertySlug]),"target":"_blank","id":"btnContact"}},[_vm._v("\n\n    Contactar\n")])}
var staticRenderFns = []

export { render, staticRenderFns }